(function() {
	angular.module('meanApp').controller('mobileNavCtrl', mobileNavCtrl);

	mobileNavCtrl.$inject = [ '$rootScope', '$scope', '$location', 'alert', 'User', 'context', '$state' ];
	function mobileNavCtrl($rootScope, $scope, $location, alert, User, context, $state) {
        var vm = this;
        
        
		$scope.mobileNavHeader = '';
		$scope.goBack = 'visible';
		$scope.iconCallback = function() {
			console.log('nothing has been defined');
		};

		$scope.clickOnBack = function() {
			var previousState = context.getPreviousState();
			if (previousState) {
				console.log('state is', $state);
				console.log('state current', $state.current.name);
				history.back();
			}
		};

		$scope.hasBackPreviousPath = function() {
			return context.getPreviousState() && context.isCurrentStateSupposedToGetBack();
		};

		context.onContextChange(function(contextInstance) {
			var params = contextInstance.get();
			($scope.goBack = params.goBack === true ? 'visible' : 'hidden'),
				//console.log('the value of context name is ', contextparam.getContextName());
				($scope.mobileNavHeader = params.contextName);
			$scope.iconName = params.iconAction;
			$scope.iconCallback = params.iconCallback;
			$scope.colorBackground = params.colorBackground;
            $scope.dropDownActions = params.dropDownActions;
            $scope.href = params.href;
		});
	}
})();
